<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs geofence_apps" style="position: relative;">
	<app-loader [showLoader]=showLoad></app-loader>
	<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap "
	 style="position: relative;">
		<div class="o-stack__cell">
			<h5>{{sectiontitle}}</h5>
			<a href="#" class="datatable_download_icon" *ngIf="downloadConfiguration && downloadConfiguration.enableDownload" (click)="downloadDataInCSV($event)" target="_blank">
				<i class="fa fa-download" aria-hidden="true" *ngIf="!tableConfig.downloadPNGIcon"></i>
                    <img src="../../../../../assets/images/Download_Icon.svg" class="downloadIcon"  *ngIf="tableConfig.downloadPNGIcon"/>

			 </a>
		</div>
	</div>
	<div class="analytics-portlet-content">

		<ngx-datatable class="datatable" [columns]="columns" [rows]="geofenceAppData" [sortType]="'single'" [columnMode]="'force'"
		 [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [limit]="10" [reorderable]="reorderable" (page)="onPageChange($event)">
			<ng-template ngFor let-column [ngForOf]="columns">
				<ngx-datatable-column
					name="{{ column.name }}"
					prop="{{ column.prop }}"
					[resizeable]="false"
					[sortable]="true"
					[cellClass]="column.cellClass"
					[headerClass]="column.headerClass"
					[comparator]="column.comparator"
				>
					<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
						<span  *ngIf="column.prop == 'formattedAppName' || column.prop == 'appName'" 
						appTooltip
						title="Tooltip"
						data-size="small"
						[options]="tooltipOptions"
						[title]="row['appName']"
						>
							{{ row[column.prop] }}
						</span>
						<span *ngIf="column.prop !== 'formattedAppName' && column.prop !== 'appName'" [title]="row[column.prop]">
							{{ row[column.prop] }}
						</span>
					</ng-template>
				</ngx-datatable-column>
			</ng-template>
		</ngx-datatable>

		<div class="no-data-container" *ngIf="!hasData">
			<div class="c-portlet__header o-stack o-stack--center o-stack--splitted  u-px-small u-py-mini c-portlet-gap pos-relative">
				<div class="o-stack__cell">
					<h5>{{sectiontitle}}</h5>
				</div>
			</div>
			<div class="map-no-data no-data-text">{{nodatamessage}}</div>
		</div>
	</div>
</div>
